/**
 * ArchiveController
 * #archive の .archive__slide / .archive__thumbnail / .archive__title を is-active で同期する
 *
 * - thumbnail クリック → 対応する slide / title に .is-active を付与、他は解除
 * - .archive__circle をアクティブ thumbnail の中心へ移動
 *   PC は縦並びのため Y のみ、SP は横並びのため X のみ動かす
 *
 * ※スライドのアニメーションは付けない（CSS 側で自由に定義）
 */
import { DeviceController } from './device-controller';

export const ArchiveController = {
  init() {
    const section = document.querySelector( '#archive' );
    if ( !section ) return;

    const slides = section.querySelectorAll( '.archive__slide' );
    const thumbs = section.querySelectorAll( '.archive__thumbnail > div:not(.archive__circle)' );
    const titles = section.querySelectorAll( '.archive__title > p' );
    const circle = section.querySelector( '.archive__circle' );
    if ( !slides.length || !thumbs.length ) return;

    const moveCircle = ( index ) => {
      if ( !circle ) return;
      const target = thumbs[ index ];
      if ( !target ) return;
      if ( DeviceController.isSP ) {
        // SP: 横並び。X を thumb 中心へ、Y も念のため中心合わせ
        const x = target.offsetLeft + target.offsetWidth / 2 - circle.offsetWidth / 2;
        const y = target.offsetTop  + target.offsetHeight / 2 - circle.offsetHeight / 2;
        circle.style.transform = `translate(${ x }px, ${ y }px)`;
      } else {
        // PC: 縦並び。X は CSS の left:50% + translateX(-50%) で列中央固定
        const y = target.offsetTop + target.offsetHeight / 2 - circle.offsetHeight / 2;
        circle.style.transform = `translate(-50%, ${ y }px)`;
      }
    };

    const setActive = ( index ) => {
      slides.forEach( ( s, i ) => s.classList.toggle( 'is-active', i === index ) );
      thumbs.forEach( ( t, i ) => t.classList.toggle( 'is-active', i === index ) );
      titles.forEach( ( t, i ) => t.classList.toggle( 'is-active', i === index ) );
      moveCircle( index );
    };

    // 画像の読み込み後 / リサイズ時に円の位置を再計算
    const currentIndex = () => {
      const idx = Array.from( slides ).findIndex( ( s ) => s.classList.contains( 'is-active' ) );
      return idx === -1 ? 0 : idx;
    };
    window.addEventListener( 'load',   () => moveCircle( currentIndex() ) );
    window.addEventListener( 'resize', () => moveCircle( currentIndex() ) );

    setActive( currentIndex() );

    thumbs.forEach( ( thumb, i ) => {
      thumb.addEventListener( 'click', () => setActive( i ) );
    } );
  },
};
